// extracted by mini-css-extract-plugin
export default {"wrapper":"fdvfFtCj0RYy15muMNoT","counter":"wMl_JKIWWyoSS7ZyBhim"};